var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Share",
    d: "m8 116c-.305 0-.613-.035-.918-.105-1.805-.43-3.082-2.04-3.082-3.895 0-36.348 4.598-66.578 60-67.953v-28.047c0-1.59.941-3.027 2.395-3.664 1.449-.633 3.148-.359 4.32.727l52 48c.82.753 1.285 1.82 1.285 2.937s-.465 2.184-1.285 2.938l-52 48c-1.168 1.086-2.867 1.367-4.32.727-1.454-.638-2.395-2.075-2.395-3.665v-27.953c-38.004.91-45.016 14.93-52.422 29.742-.687 1.379-2.09 2.211-3.578 2.211zm60-40c2.211 0 4 1.789 4 4v22.863l42.102-38.863-42.102-38.863v22.863c0 2.211-1.789 4-4 4-44.188 0-53.703 17.09-55.574 44.387 8.285-11.129 22.406-20.387 55.574-20.387z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.98e307d0bf239342df849dd3b3f4b8c9.svg";
export { ForwardRef as ReactComponent };